import { useState, useCallback, useEffect } from "react";
import apiClient from "utils/apiClient";

const API_BASE_URL = "/olitask-service/api/v1/guest/donations";

const useGuestDonations = () => {
  const [donations, setDonations] = useState([]);
  const [selectedDonation, setSelectedDonation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);

const fetchDonations = useCallback(async (page = 0, size = 20, search = null, status = null) => {
    setLoading(true);
    setError(null);
    try {
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('size', size);
      if (search) params.append('search', search);
      if (status) params.append('status', status);

      const response = await apiClient.get(`${API_BASE_URL}?${params.toString()}`);
      const data = response.data;
      
      if (Array.isArray(data)) {
        setDonations(data);
        setTotalPages(1);
        setTotalElements(data.length);
      } else {
        setDonations(data.content || data || []);
        setTotalPages(data.totalPages || 1);
        setTotalElements(data.totalElements || data.length || 0);
      }
      return data;
    } catch (err) {
      setError(err.message);
      console.error('[useGuestDonations] Error fetching donations:', err);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchDonationById = useCallback(async (id) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.get(`${API_BASE_URL}/${id}`);
      setSelectedDonation(response.data);
      return response.data;
    } catch (err) {
      setError(err.message);
      console.error("[useGuestDonations] Error fetching donation:", err);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  // Auto-fetch on mount
  useEffect(() => {
    fetchDonations();
  }, []);

  return {
    donations,
    selectedDonation,
    loading,
    error,
    totalPages,
    totalElements,
    fetchDonations,
    fetchDonationById,
    setSelectedDonation,
  };
};

export default useGuestDonations;